// Reusable UI primitives extracted from BusinessAnalytics.jsx during
// Step 4.1. Dark-theme (staff portal) design — consistent with the
// rest of /app/*. These are presentational only; no state, no data.

import { ArrowUp, ArrowDown, Minus } from 'lucide-react'

export function Card({ children, className = '' }) {
  return (
    <div className={`bg-gray-900 border border-gray-800 rounded-xl p-4 ${className}`}>
      {children}
    </div>
  )
}

export function KpiCard({ label, value, sub, icon: Icon, color = 'text-white' }) {
  return (
    <Card>
      <div className="flex items-start justify-between">
        <div className="min-w-0">
          <p className="text-gray-400 text-xs mb-1 truncate">{label}</p>
          <p className={`text-xl font-bold ${color} truncate`}>{value}</p>
          {sub && <p className="text-gray-500 text-xs mt-1 truncate">{sub}</p>}
        </div>
        {Icon && <Icon size={20} className="text-gray-600 flex-shrink-0 ml-2" />}
      </div>
    </Card>
  )
}

export function SectionTitle({ children }) {
  return <h3 className="text-white font-semibold text-sm mb-3 mt-6 first:mt-0">{children}</h3>
}

export function EmptyState({ message }) {
  return (
    <div className="text-center py-8 text-gray-500 text-sm">{message || 'No data for this period'}</div>
  )
}

export function Th({ children, className = '' }) {
  return <th className={`text-left text-gray-400 text-xs font-medium px-3 py-2 border-b border-gray-800 ${className}`}>{children}</th>
}

export function Td({ children, className = '' }) {
  return <td className={`px-3 py-2 text-sm text-gray-300 border-b border-gray-800/50 ${className}`}>{children}</td>
}

export function Badge({ label, color }) {
  const colors = {
    green: 'bg-green-500/20 text-green-400 border-green-500/30',
    red: 'bg-red-500/20 text-red-400 border-red-500/30',
    amber: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
    orange: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
    gray: 'bg-gray-700/50 text-gray-400 border-gray-600/30',
    blue: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  }
  return (
    <span className={`inline-block text-[10px] font-semibold px-1.5 py-0.5 rounded border ${colors[color] || colors.gray}`}>
      {label}
    </span>
  )
}

export function HorizontalBar({ value, max, color = 'bg-orange-500' }) {
  const w = max > 0 ? Math.min((value / max) * 100, 100) : 0
  return (
    <div className="w-full bg-gray-800 rounded-full h-2 overflow-hidden">
      <div className={`h-full rounded-full ${color}`} style={{ width: `${w}%` }} />
    </div>
  )
}

export function ChangeArrow({ value }) {
  if (value > 0) return <ArrowUp size={12} className="text-green-400 inline" />
  if (value < 0) return <ArrowDown size={12} className="text-red-400 inline" />
  return <Minus size={12} className="text-gray-500 inline" />
}
